import type { PlanId, RestaurantId } from '~/lib/graphql/scalars'
import { FavoriteButton } from '../components'
import type { Variant } from '../components'
import { useFavoriteState, useTogglePlanFavorite } from './hooks'

export function FavoritePlanButton(
  props: {
    restaurantId: RestaurantId
    planId: PlanId
  } & Variant
) {
  const state = useFavoriteState(props.restaurantId, props.planId)
  const { toggle, isPending } = useTogglePlanFavorite(props.restaurantId, props.planId)

  return <FavoriteButton state={state} isPending={isPending} toggle={toggle} {...props} />
}
